const ssrShortcodes = {
  'WHEELCHAIR': 'WCHR',
};

export default ssrShortcodes;

